window.Vlitejs.registerProvider('youtube', window.VlitejsYoutube);
function onScrollTop() {
  if(window.matchMedia("(max-width: 992px)")) {
    if(document.getElementById('alertErrorLogin')) {
      document.body.scrollTop = 0; 
      document.documentElement.scrollTop = 0;
    }
  }
}

function movilDelegados () {
  document.querySelector('.cont-medico').classList.add('show')
  document.body.classList.add('not-scroll')
  document.querySelector('.collapse-general').style.top = '64px'
  document.querySelector('.collapse-general').style.maxHeight = 'calc(100% - 1rem - 3rem)'
  document.querySelector('.collapse-general').classList.add('open-med')

}
function accPerfil() {
  var anchoVentana = window.innerWidth;

  if (anchoVentana >= 992) {
    document.querySelectorAll('#accPerfil .accordion-collapse').forEach(acc => {
      acc.classList.add('show')
    })
  }
}
if(document.querySelector('.btn-back-delegados')) {
  document.querySelector('.btn-back-delegados').addEventListener('click', ()=> {
    document.querySelector('.cont-medico').classList.remove('show')
    document.body.classList.remove('not-scroll')
    document.querySelector('.collapse-general').style.top = ''
    document.querySelector('.collapse-general').classList.remove('open-med')
  })
}

function showFilters(filtroMov) {
  if(window.matchMedia('(max-width: 739px)').matches) { 
    filtroMov.classList.remove('show')
  } else {
    filtroMov.classList.add('show')
    if(document.querySelector('.cont-medico').classList.contains('show')) {
      filtroMov.style.top = '14%'
    }
  }
}

if(document.querySelector('.filter-movil')) {
  document.querySelectorAll('.filter-movil').forEach((btn) => {
    btn.addEventListener('click', (el)=> {
      document.body.classList.toggle('overflow-hidden')
      document.body.classList.toggle('h-100')
    })
  })
}


window.addEventListener("resize", () => {
  if(document.getElementById('filterMobil')) {
    showFilters(document.getElementById('filterMobil'))
  }
  accPerfil
});
window.addEventListener("load", () => {

  //$('.select2-delegados').select2();

  if(document.getElementById('filterMobil')) {
    showFilters(document.getElementById('filterMobil'))
  }
  accPerfil()
   if(document.querySelector('.check-toggle')) {
    if (document.querySelector('.check-toggle').checked) {
        document.querySelectorAll('.task').forEach(task =>  {
          if(task.classList.contains('completada')) {
              task.style.display = 'flex'
            } else {
                task.style.display = 'none'
            }
        })
    } else {
        document.querySelectorAll('.task').forEach(task =>  {
            if(task.classList.contains('completada')) {
                task.style.display = 'none'
            } else {
                task.style.display = 'flex'
            }
        })
      }
    document.querySelector('.check-toggle').addEventListener('change', function() {
        if (this.checked) {
          document.querySelectorAll('.task').forEach(task =>  {
            if(task.classList.contains('completada')) {
                task.style.display = 'flex'
            } else {
                task.style.display = 'none'
            }
          })
        } else {
            document.querySelectorAll('.task').forEach(task =>  {
                if(task.classList.contains('completada')) {
                    task.style.display = 'none'
                } else {
                    task.style.display = 'flex'
                }
            })
        }
      });
   }
   if(window.matchMedia('(max-width: 740px)')) {
    if(document.querySelector('.back-steps .dropdown-toggle')) {
      document.querySelectorAll('.back-steps .dropdown-toggle').forEach((drop) => {
        drop.addEventListener('click', () => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth' 
          });
          if(drop.classList.contains('show')) {
            document.body.style.height = '100vh'
            document.body.style.overflow = 'hidden'
            
          } else {
            document.body.style.height = ''
            document.body.style.overflow = ''
          }
        })
      })
    }
   }
});
  
  var videop = []

  var swiperheader;
  if (document.querySelector('.swiper-header')) {
    document.querySelectorAll('.swiper-header').forEach(sheader => {
       swiperheader = new Swiper(sheader, {
        slidesPerView: "auto",
        spaceBetween: 0,
        navigation: {
          nextEl: ".swiper-button-next",
      
          prevEl: ".swiper-button-prev",
        },
      });
    })
  }


